<template>
    <div>
        <!-- Floating Button with Tailwind CSS for styling -->
        <button @click="showModal = true" class="fixed bottom-1 sm:bottom-24 left-1 sm:left-4 brand-button text-sm sm:text-lg text-white font-bold py-2 sm:py-3 px-4 sm:px-5 rounded-full shadow-md">Feedback</button>

        <dialog-modal :show="showModal" @close="close">
            <template #title>
                <div class="flex items-center justify-between">
                    <span>Tell Us What You Think</span>
                    <modal-close @close="close" />
                </div>
            </template>

            <template #content>
                <!-- Success message -->
                <div v-if="showSuccessMessage" class="p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg dark:bg-green-200 dark:text-green-800" role="alert"><span class="font-medium">Success!</span> Your feedback has been submitted. Thank you!</div>

                <p class="text-sm sm:text-md mx-4 mb-6">Help us improve by sharing your feedback or suggestions. Don't hold back—whether it’s a game-changing idea, a tiny tweak, or just something you've been itching to say, we're all ears.</p>
                <form ref="feedbackForm" @submit.prevent="submitFeedback" class="space-y-4">
                    <div>
                        <label for="feedback" class="block text-sm font-medium text-gray-700">Feedback:</label>
                        <select v-model="form.type" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500">
                            <option value="suggestion">Suggestion</option>
                            <option value="bug">Bug Report</option>
                            <option value="other">Other</option>
                        </select>
                    </div>

                    <div>
                        <label for="body" class="block text-sm font-medium text-gray-700">Message:</label>
                        <textarea v-model="form.body" id="body" name="body" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 min-h-[100px]"></textarea>
                    </div>
                </form>
            </template>

            <template #footer>
                <jet-button @click.native="submitFeedback"> Send </jet-button>
            </template>
        </dialog-modal>
    </div>
</template>

<script>
import ModalClose from "@/Components/ModalClose"
import JetButton from "@/Jetstream/Button"
import DialogModal from "@/Jetstream/DialogModal"

export default {
    components: { DialogModal, JetButton, ModalClose },
    data() {
        return {
            form: this.$inertia.form({
                type: "suggestion",
                body: "",
            }),
            showModal: false,
            showSuccessMessage: false,
        }
    },
    methods: {
        submitFeedback() {
            this.form.post(route("feedback"), {
                onSuccess: () => {
                    this.resetForm()
                    this.showSuccessMessage = true // Show success message

                    // Hide the message after 6 seconds
                    setTimeout(() => {
                        this.showSuccessMessage = false
                        this.close() // Optionally close the modal
                    }, 6000)
                },
                onError: () => {
                    // Handle errors, perhaps by showing error messages or highlighting invalid form fields
                },
            })
        },

        close() {
            this.showModal = false
        },

        resetForm() {
            this.form.reset()
        },
    },
}
</script>
